import React from 'react';
import YouTube from 'react-youtube';


export default function YoutubePlayer(props) {
    const { videoSrc, playerVars, setVideoSrc } = props
    const { id: videoId } = videoSrc

    const opts = {
        height: '480',
        width: '640',
        playerVars: {
            autoplay: 1,
            controls: 0,
            rel: 0,
            showinfo: 0,
            mute: 1,
            loop: 1
        }
    }
    return (<YouTube videoId={videoId} opts={opts} onEnd={() => {
        window.location.reload()
        // console.log('====================================');
        // console.log('ended');
        // console.log('====================================');
        // setVideoSrc(s => ({ ...s, startTime: new Date().valueOf() }))
    }} />);
}